<template>
  <div class="news">
      <div class="banner"><img src="./images/banner-news.jpg" alt="" width="100%"></div>
      <div class="new-main">
        <p class="tit clearfix">
            <span><a href="/">首页</a></span>
            <span class="arr-bold">&gt;</span>
            <span class="font-blue">亚商动态</span>
        </p>
        <div class="content">
          <div class="newsList">
            <ul>
              <li class="clearfix" v-for="(item, index) in newsList" :key="index">
                <a :href="`/newsDetail/${item.id}`">
                  <span class="news-title fl">{{item.title}}</span>
                  <span class="fr">{{item.time}}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <!-- <div class="page-control">
          <ul>
            <li>上一页</li>
            <li class="active">1</li>
            <li>下一页</li>
          </ul>
        </div> -->
      </div>
    <div style="width: 100%;height: 600px;"></div>
      <go-top></go-top>
  </div>
</template>
<script>
import goTop from "../../common/go-top.vue";
  const newsList = require('../../../static/data/news-list');
export default{
  name: 'News',
  components: {
    goTop
  },
  data () {
    return {
      newsList: newsList,
      headerActive: null
    }
  },
  methods: {
    // gotoDetail: function(index){
    //   this.$route.push({path: '/newsDetail', query: {id: index}});
    // }
  }
}
</script>

<style scoped>
.news{
  min-width: 1200px;
}
.banner{
  width: 100%;
}
.new-main{
  max-width: 1200px;
  margin: 0 auto;
  margin-bottom: 48px;
}
.news p{
    height: 46px;
    line-height: 46px;
    font-size: 14px;
    text-align: left;
    /* padding-left: 20px; */
}
.new-main .tit a{
  color: #333333;
}
.new-main .tit span{
  cursor: pointer;
}
.new-main .arr-bold{
  font-weight: 600;
}
.font-blue{
  color: #003B83;
}
.content{
  background: #fff;
}
.newsList ul{
  padding: 20px 90px;
  margin-bottom: 48px;
  border: 1px solid #ced7e2;
}
.newsList li{
  color: #999;
  line-height: 46px;
  cursor: pointer;
  border-bottom: 1px solid #ddd;
}
.newsList li:hover{
  color: #333333;
}
/* .page-control li{
  display: inline-block;
  width: 46px;
  height: 46px;
  line-height: 46px;
  text-align: center;
  background: #fff;
  border: 1px solid #ddd;
  cursor: pointer;
}
.page-control li:first-child,.page-control li:last-child{
  width: 94px;
}
.page-control li:hover{
  border: 1px solid #333333;
}
.page-control .active{
  border: 1px solid #333333;
} */
</style>




// WEBPACK FOOTER //
// src/components/news/News.vue